module.exports = __webpack_public_path__ + "yz/img/国通.815b69f0.jpg";